import React from 'react'

import { Box, Divider } from '@mui/material'
import DescriptionIcon from '@mui/icons-material/Description';
import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import {useRecoilValue} from "recoil";
import { CONTRACT_STATUS } from '../../constants/contract';
import { buildButtonActon } from '../../utils/mobileCommunication';
import { URL_PARAMS } from '../../constants/urlParams/urlParams';
import {createUrlParams} from "../../utils/urlParams";
import {appState} from "../../atoms/agreements/state";
import {
  StyledPaper,
  StyledTitle,
  StyledButton,
  StyledTitleWarning,
  StyledTitleStatus,
  StyledValueStatus
} from "./styles";
import colors from '../../themes/colors';



function Detail({token, template, groupIds, includeCats, setDocumentSigned, excludeCats }) {
  const navigate = useNavigate();
  const apps = useRecoilValue(appState);

  const handleView = () => {
    if(template.status === CONTRACT_STATUS.AGREED && !template.warning) {
      if (window.TSAMessageChannel) {
        const json = JSON.stringify(buildButtonActon('open-pdf', template.contract_url, template.name));
        window.TSAMessageChannel.postMessage(json);
      }
      else {
        setDocumentSigned({
          contractUrl: `${template.contract_url}#toolbar=0&navpanes=0&scrollbar=0`,
          isOpen: true,
        });
      }
      return;
    }

    const params = {
      [URL_PARAMS.TOKEN]: token,
      [URL_PARAMS.GROUP_IDS]: groupIds,
      [URL_PARAMS.FROM_LIST]: true,
      [URL_PARAMS.INCLUDES]: includeCats,
      [URL_PARAMS.EXCLUDES]: excludeCats,
      [URL_PARAMS.APP_VERSION]: apps.app_version,
    }

    navigate(`/document/${template?.id}?${createUrlParams(params)}`);
  }

  return (
    <StyledPaper elevation={1}>
      <Box display='flex' justifyContent='space-between' px={2} pt={2} pb={template.warning ? 0.5 : 2} alignItems={'center'}>
        <Box display='flex' alignItems='center' maxWidth={'60%'} ml={-0.5}>
          <DescriptionIcon fontSize='small' sx={{ color: colors.greenFifth }}/>
          <StyledTitle display='inline' variant="h6">{template?.name} </StyledTitle>
        </Box>
        <Box>
          <StyledButton variant="contained" onClick={handleView} disableElevation>View</StyledButton>
        </Box>
      </Box>
      <Box px={2} my={template.warning ? 0.5 : 0}>
        {template.warning && <StyledTitleWarning display='inline' variant="h6" color='error'>{CONTRACT_STATUS.RENEW_NEEDED}</StyledTitleWarning>}
      </Box>

      <Divider/>
      <Box px={2} display='flex' py={1} alignItems={'flex-end'}>
        <StyledTitleStatus display='inline' variant="h6">Status</StyledTitleStatus>
        <Box>
          {
            [CONTRACT_STATUS.NOT_YET_AGREED, CONTRACT_STATUS.EXPIRED].includes(template.status)
            ? <StyledValueStatus display='inline' variant="h6" color='error'>{template.status}</StyledValueStatus>
            : <StyledValueStatus display='inline' variant="h6" className={clsx({
              statusSigned: !template.warning,
              statusWarning: template.warning,
            })}>{template.status} - {new Date(template.signed_ts).toLocaleDateString("en-US", { year: 'numeric', month: '2-digit', day: '2-digit' })} </StyledValueStatus>
          }
        </Box>
      </Box>
    </StyledPaper>
  )
}

export default Detail
